import { Filter } from './types/podlet';
import { Subvertical, Vertical } from './types/ast';

export function travelSearchKeys(
    searchFilters: Filter,
    vertical: Vertical,
    subvertical: Subvertical,
) {
    if (!searchFilters.search_key && vertical === 'travel' && subvertical) {
        if (subvertical === 'flight') {
            searchFilters.search_key = 'SEARCH_ID_TRAVEL_FLIGHT';
        } else if (subvertical === 'prepackage') {
            searchFilters.search_key = 'SEARCH_ID_TRAVEL_LASTMINUTE';
        } else if (subvertical === 'lastminute') {
            searchFilters.search_key = 'SEARCH_ID_TRAVEL_PREPACKAGE';
        } else if (subvertical === 'currency') {
            searchFilters.search_key = 'SEARCH_ID_TRAVEL_CURRENCY';
        } else if (subvertical === 'holiday_rental') {
            searchFilters.search_key = 'SEARCH_ID_TRAVEL_HOLIDAYRENTALS';
        } else if (subvertical === 'hotel') {
            searchFilters.search_key = 'SEARCH_ID_TRAVEL_HOTEL';
        }
    }
    return searchFilters;
}
/**
 * @param filter
 * @param vertical
 * @param subvertical
 */
export function preProcessTravelFilter(
    filter: Filter,
    vertical: Vertical,
    subvertical?: Subvertical,
): Filter {
    if (vertical === 'travel') {
        const { destinasjon, til } = filter;

        if (destinasjon) {
            if (Array.isArray(destinasjon)) {
                console.warn(`Destination data as array is not supported `);
                return travelSearchKeys(filter, vertical, subvertical);
            }
            if (typeof destinasjon === 'object') {
                const { by, land } = destinasjon;
                if (by) {
                    filter['city'] = [by];
                }
                if (land) {
                    filter['country'] = [land];
                }
            }
            if (subvertical === 'flight') {
                // copy the flight "destinasjon" value into the search_filter_targeting_mappings DB format
                if (typeof destinasjon === 'string') {
                    const locations = destinasjon.split(';');
                    if (locations.length > 0) {
                        const city = locations[0];
                        if (city) {
                            filter['city'] = [city];
                        }
                    }
                    if (locations.length > 1) {
                        const country = locations[1];
                        if (country) {
                            filter['country'] = [country];
                        }
                    }
                }
            }

            if (subvertical === 'holiday_rental') {
                // split the fhh "destinasjon" value into the search_filter_targeting_mappings DB format
                if (typeof destinasjon === 'string') {
                    const locations = destinasjon.split(', ');
                    if (locations.length > 0) {
                        filter['country'] = [locations[locations.length - 1]];
                    }
                    if (locations.length > 1) {
                        filter['city'] = [locations[locations.length - 2]];
                    }
                }
            }

            if (subvertical === 'lastminute') {
                // split the lms "destinasjon" value into the search_filter_targeting_mappings DB format
                // example: Europa;Storbritannia;England;London
                if (typeof destinasjon === 'string') {
                    const locations = destinasjon.split(';');
                    if (locations.length === 1) {
                        filter['country'] = [locations[0]];
                    }
                    if (locations.length > 1) {
                        filter['country'] = [locations[1]];
                    }
                    if (locations.length > 3) {
                        filter['city'] = [locations[3]];
                    } else if (locations.length > 2) {
                        filter['city'] = [locations[2]];
                    }
                }
            }
            delete filter.destinasjon;
        }

        if (subvertical === 'hotel') {
            // copy the accommodation "land" value into the search_filter_targeting_mappings DB format
            if (filter.land && Array.isArray(filter.land)) {
                filter['country'] = filter.land;
            }

            // copy the accommodation "til" value into the search_filter_targeting_mappings DB format
            if (filter.til && Array.isArray(filter.til)) {
                filter['city'] = filter.til;
            }
        }
        if (subvertical === 'prepackage') {
            // copy the prepackage "til" into the search_filter_targeting_mappings DB format
            if (til && Array.isArray(til) && til.length > 0) {
                const locations = til[0].split(';');

                if (locations.length === 3) {
                    const city = locations[2];
                    if (city) {
                        filter['city'] = [city];
                    }
                    const country = locations[1];
                    if (country) {
                        filter['country'] = [country];
                    }
                    const continent = locations[0];
                    if (continent) {
                        filter['continent'] = [continent];
                    }
                }
                if (locations.length === 2) {
                    const country = locations[1];
                    if (country) {
                        filter['country'] = [country];
                    }

                    const continent = locations[0];
                    if (continent) {
                        filter['continent'] = [continent];
                    }
                }
                if (locations.length === 1) {
                    const continent = locations[0];
                    if (continent) {
                        filter['continent'] = [continent];
                    }
                }
                delete filter.til;
            }
        }
    }
    return travelSearchKeys(filter, vertical, subvertical);
}
